export default __webpack_public_path__ + "static/media/2267_open.aa9cef04.jpg";